import { Link } from 'react-router-dom';
import { ArrowRight, Calendar } from 'lucide-react';
import { motion } from 'framer-motion';
import { getImageUrl } from '../lib/api';

export default function BlogCard({ article }) {
  const date = article.publish_date
    ? new Date(article.publish_date).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
    : '';

  return (
    <motion.div
      whileHover={{ y: -4 }}
      transition={{ duration: 0.3, ease: [0.25, 0.1, 0.25, 1] }}
    >
      <Link
        to={`/blog/${article.slug}`}
        data-testid={`blog-card-${article.slug}`}
        className="group flex flex-col gap-4 cursor-pointer glass-card rounded-2xl overflow-hidden hover:border-yellow-400/10 transition-all duration-400"
      >
        <div className="relative overflow-hidden aspect-[16/10]">
          {article.featured_image ? (
            <img
              src={getImageUrl(article.featured_image)}
              alt={article.title}
              className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              loading="lazy"
              width={640}
              height={400}
            />
          ) : (
            <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-zinc-900 to-zinc-800">
              <span className="text-zinc-600 text-sm font-['Outfit']">GuideAutoFrance</span>
            </div>
          )}
          <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent" />
          {article.category && (
            <span className="absolute top-4 left-4 bg-yellow-400/90 text-black text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">
              {article.category}
            </span>
          )}
        </div>
        <div className="p-5 pt-0 space-y-2.5">
          {date && (
            <div className="flex items-center gap-2 text-zinc-400 text-xs">
              <Calendar className="w-3 h-3" />
              <span>{date}</span>
            </div>
          )}
          <h3 className="font-['Outfit'] font-semibold text-white text-lg leading-tight group-hover:text-yellow-400 transition-colors duration-300">
            {article.title}
          </h3>
          <p className="text-zinc-400 text-sm line-clamp-2 leading-relaxed">{article.excerpt}</p>
          <span className="inline-flex items-center gap-1.5 text-yellow-400 text-sm font-medium group-hover:gap-2.5 transition-all duration-300">
            Lire l'article <ArrowRight className="w-4 h-4" />
          </span>
        </div>
      </Link>
    </motion.div>
  );
}
